export default __webpack_public_path__ + "static/media/basic_2.9b8e40f9.jpg";